module.exports = __webpack_public_path__ + "static/MacWithImage-05eaa88aa7de09067e7adbb9ae957af3.png";